/**
 * Wishlist Funktionalität
 */
class Wishlist {
  constructor() {
    this.storageKey = 'shopify_wishlist';
    this.translations = {
      'de': {
        empty: 'Deine Wunschliste ist leer.',
        remove: 'Entfernen'
      },
      'en': {
        empty: 'Your wishlist is empty.',
        remove: 'Remove'
      },
      'fr': {
        empty: 'Votre liste de souhaits est vide.',
        remove: 'Retirer'
      }
    };
    this.init();
  }

  init() {
    this.updateAllButtons();
    this.bindEvents();
    setTimeout(() => this.updateCounter(), 400);
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.wishlist-btn')) {
        e.preventDefault();
        const btn = e.target.closest('.wishlist-btn');
        this.toggleProduct(btn);
      }
      
      if (e.target.closest('.wishlist-remove')) {
        e.preventDefault();
        const productId = e.target.closest('.wishlist-remove').dataset.productId;
        this.removeProduct(productId);
      }
    });

    const drawerDetails = document.querySelector('details[id*="menu"], details.menu-drawer');
    if (drawerDetails) {
      const observer = new MutationObserver(() => {
        if (drawerDetails.hasAttribute('open')) {
          setTimeout(() => this.updateCounter(), 400);
        }
      });
      observer.observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
    }
  }

  getWishlist() {
    const wishlist = localStorage.getItem(this.storageKey);
    return wishlist ? JSON.parse(wishlist) : [];
  }

  saveWishlist(wishlist) {
    localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
    this.updateCounter();
  }

  toggleProduct(btn) {
    const product = {
      id: btn.dataset.productId,
      handle: btn.dataset.productHandle,
      title: btn.dataset.productTitle,
      price: btn.dataset.productPrice,
      image: btn.dataset.productImage
    };

    let wishlist = this.getWishlist();
    const index = wishlist.findIndex(item => item.id === product.id);

    if (index > -1) {
      wishlist.splice(index, 1);
      btn.classList.remove('active');
      btn.querySelector('.wishlist-icon').textContent = '♡';
      btn.querySelector('.wishlist-text').textContent = btn.dataset.textAdd;
    } else {
      wishlist.push(product);
      btn.classList.add('active');
      btn.querySelector('.wishlist-icon').textContent = '♥';
      btn.querySelector('.wishlist-text').textContent = btn.dataset.textAdded;
    }

    this.saveWishlist(wishlist);
  }

  removeProduct(productId) {
    let wishlist = this.getWishlist();
    wishlist = wishlist.filter(item => item.id !== productId);
    this.saveWishlist(wishlist);
    this.renderWishlistPage();
    this.updateAllButtons();
  }

  updateAllButtons() {
    const wishlist = this.getWishlist();
    const buttons = document.querySelectorAll('.wishlist-btn');
    
    buttons.forEach(btn => {
      const productId = btn.dataset.productId;
      const isInWishlist = wishlist.some(item => item.id === productId);
      
      if (isInWishlist) {
        btn.classList.add('active');
        btn.querySelector('.wishlist-icon').textContent = '♥';
        btn.querySelector('.wishlist-text').textContent = btn.dataset.textAdded;
      } else {
        btn.classList.remove('active');
        btn.querySelector('.wishlist-icon').textContent = '♡';
        btn.querySelector('.wishlist-text').textContent = btn.dataset.textAdd;
      }
    });
  }

  updateCounter() {
    const wishlist = this.getWishlist();
    const counters = document.querySelectorAll('.wishlist-counter');
    
    counters.forEach(counter => {
      counter.textContent = wishlist.length;
      if (wishlist.length > 0) {
        counter.style.display = 'flex';
      } else {
        counter.style.display = 'none';
      }
    });
  }

  getTranslation(key) {
    const locale = document.documentElement.lang || 'de';
    const lang = locale.split('-')[0];
    return this.translations[lang]?.[key] || this.translations['de'][key];
  }

  renderWishlistPage() {
    const container = document.querySelector('.wishlist-container');
    if (!container) return;

    const wishlist = this.getWishlist();
    const emptyText = this.getTranslation('empty');
    const removeText = this.getTranslation('remove');
    
    if (wishlist.length === 0) {
      container.innerHTML = `<p class="wishlist-empty">${emptyText}</p>`;
      return;
    }

    let html = '<div class="wishlist-grid">';
    
    wishlist.forEach(product => {
      const price = this.formatPrice(product.price);
      html += `
        <div class="wishlist-item">
          <a href="/products/${product.handle}" class="wishlist-item-image">
            <img src="${product.image}" alt="${this.escapeHtml(product.title)}" loading="lazy">
          </a>
          <div class="wishlist-item-details">
            <h3><a href="/products/${product.handle}">${this.escapeHtml(product.title)}</a></h3>
            <p class="wishlist-item-price">${price}</p>
            <button class="wishlist-remove" data-product-id="${product.id}">
              ${removeText}
            </button>
          </div>
        </div>
      `;
    });
    
    html += '</div>';
    container.innerHTML = html;
  }

  formatPrice(cents) {
    const locale = document.documentElement.lang || 'de-DE';
    const currency = window.Shopify?.currency?.active || 'EUR';
    
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

// Initialisierung
document.addEventListener('DOMContentLoaded', () => {
  window.wishlist = new Wishlist();
  
  if (document.querySelector('.wishlist-container')) {
    window.wishlist.renderWishlistPage();
  }
});